/**
 * TaxSetu AI - API Configuration
 * ===============================
 * Smart API URL that handles both preview and production environments.
 */

// Smart API URL: Use same origin for custom domains, env var for preview
export const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  const currentOrigin = window.location.origin;
  
  // If we're on a custom domain (not preview/emergent), use same origin
  if (!currentOrigin.includes('preview.emergentagent.com') && 
      !currentOrigin.includes('emergent.host')) {
    return currentOrigin;
  }
  return envUrl;
};

export const API_BASE_URL = getApiBaseUrl();
export const API_URL = `${API_BASE_URL}/api`;
